import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "custom-player-controls"
}

import axios from 'axios';
import { VideoPlayer } from '@videojs-player/vue';
import 'video.js/dist/video-js.css';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoPlayerCustom',
  props: {
  videoSrc: String,
  poster: { type: String, default: '' },
  title: String
},
  setup(__props) {

const props = __props;

const downloadItem = (url: string, label: string) => {
  axios.get(url, { responseType: 'blob' })
    .then((response) => {
      const blob = new Blob([response.data], { type: 'video/mp4' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = label;
      link.click();
      URL.revokeObjectURL(link.href);
    }).catch(console.error);
};

return (_ctx: any,_cache: any) => {
  return (__props.videoSrc)
    ? (_openBlock(), _createBlock(_unref(VideoPlayer), {
        key: 0,
        src: __props.videoSrc,
        poster: __props.poster,
        controls: "",
        loop: false,
        volume: 0.6,
        ref: "player"
      }, {
        default: _withCtx(() => [
          (__props.videoSrc && __props.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.videoSrc && __props.title)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (downloadItem(__props.videoSrc, __props.title)), ["prevent"])),
                      class: "video-control-download-control"
                    }, _cache[1] || (_cache[1] = [
                      _createElementVNode("svg", { class: "icon-download" }, [
                        _createElementVNode("use", { href: "/sprite.svg#download" })
                      ], -1)
                    ])))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["src", "poster"]))
    : _createCommentVNode("", true)
}
}

})